import { enableProdMode, provideZoneChangeDetection } from '@angular/core';

import {
	provideHttpClient,
	withInterceptorsFromDi,
} from '@angular/common/http';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { bootstrapApplication } from '@angular/platform-browser';
import {
	InMemoryScrollingFeature,
	InMemoryScrollingOptions,
	provideRouter,
	withComponentInputBinding,
	withInMemoryScrolling,
} from '@angular/router';
import { withNgxsReduxDevtoolsPlugin } from '@ngxs/devtools-plugin';
import { withNgxsFormPlugin } from '@ngxs/form-plugin';
import { withNgxsStoragePlugin } from '@ngxs/storage-plugin';
import { provideStore } from '@ngxs/store';
import { BasicState } from 'src/shared/state/basic.state';
import { CallingTreeState } from 'src/shared/state/calling-tree.state';
import { ConfigState } from 'src/shared/state/config.state';
import { CrisisTeamState } from 'src/shared/state/crisis-team.state';
import { HousingState } from 'src/shared/state/housing.state';
import { ReportState } from 'src/shared/state/report.state';
import { UserState } from 'src/shared/state/user.state';
import { AppComponent } from './app/app.component';
import { AppPreloadingStrategy } from './app/app.preloading';
import { APP_ROUTES } from './app/app.routes';
import { environment } from './environments/environment';
import { AuthState } from './shared/state/auth.state';
import { MainState } from './shared/state/main.state';
import { TravelState } from './shared/state/travel.state';

if (environment.production) {
	enableProdMode();
}

const inMemoryScrollingOptions: InMemoryScrollingOptions = {
	scrollPositionRestoration: 'enabled',
	anchorScrolling: 'enabled',
};

const inMemoryScrollingFeature: InMemoryScrollingFeature =
	withInMemoryScrolling(inMemoryScrollingOptions);

bootstrapApplication(AppComponent, {
	providers: [
		provideZoneChangeDetection(),
		provideRouter(
			APP_ROUTES,
			inMemoryScrollingFeature,
			withComponentInputBinding()
		),
		provideStore(
			[
				MainState,
				AuthState,
				TravelState,
				BasicState,
				UserState,
				HousingState,
				CallingTreeState,
				CrisisTeamState,
				ReportState,
				ConfigState,
			],
			{
				developmentMode: !environment.production,
			}
		),
		withNgxsStoragePlugin({ keys: ['auth'] }),
		withNgxsReduxDevtoolsPlugin({
			disabled: environment.production,
		}),
		withNgxsFormPlugin(),
		AppPreloadingStrategy,
		{
			provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
			useValue: { subscriptSizing: 'dynamic' },
		},
		provideHttpClient(withInterceptorsFromDi()),
	],
}).catch((err) => console.log(err));
